<template>
  <div class="m-check-table"
    :style="{
      'overflow-y': 'auto',
      '--menu-width': menuWidth,
    }"
  >
    <div class="m-check-table-header border-top" :class="isHideGroup ? 'print' : ''">
      <div v-if="!isHideGroup" class="m-check-table-menu m-check-table-item border-bottom"><span>{{ title }}</span></div>
      <div>
        <slot name="header"></slot>
      </div>
    </div>
    <div class="m-check-table-body m-check-table-menu"
         :class="isHideGroup ? 'print' : ''"
         v-for="(menu, index) in menus"
         :key="`m_check_table_menu_${typeof menu === 'string' ? menu : index}`">
      <div v-if="typeof menu === 'string'" class="border-bottom">
        <div class="m-check-table-item">
          <span class="px-4">{{ menu }}</span>
        </div>
      </div>
      <div v-if="typeof menu === 'object' && !isHideGroup" >
        <div style="display: grid; grid-template-columns: 70px 1fr;">
          <span class="px-4 border-bottom" style="display: flex; align-items: center; justify-content: center; text-align: center;">{{ menu.name }}</span>
          <div class="border-left" >
            <div v-for="(menu2, index2) of menu.child"
                 :key="`m_check_table_menu_child_${typeof menu2 === 'string' ? menu2 : index2}`">
              <div style="display: grid; grid-template-columns: 145px 151px;">
                <span class="px-4 border-bottom" style="display: flex; align-items: center; justify-content: center; text-align: center;">{{ menu2.name }}</span>
                <div class="border-left border-right" >
                  <div v-for="(menu3, index3) of menu2.child"
                       :key="`m_check_table_menu_child_child_${typeof menu3 === 'string' ? menu3 : index3}`">
                    <div class="w-full m-check-table-item border-bottom"
                      :style="{ minHeight: `${ menu3.child ? 50 * menu3.child.length : 50}px`}">
                      <span class="px-4 ">{{ menu3.name }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="typeof menu === 'string'" >
        <slot :menu="menu"></slot>
      </div>
      <div v-if="typeof menu === 'object'" >
        <slot :menu="menu.name"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MCheckTable',
  props: {
    title: {
      type: String,
      default: () => {
        return '구분'
      }
    },
    menus: {
      type: Array,
      default: () => {
        return []
      }
    },
    menuWidth: {
      type: String,
      default: () => {
        return '128px'
      }
    },
    isHideGroup: Boolean,
  }
}
</script>

<style lang="scss" scoped>

.m-check-table-menu {
  min-width: var(--menu-width);
  width: var(--menu-width);
}
.m-check-table-item {
  min-height: 50px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  color: #3C3C3C;
  font-size: 14px;
  font-weight: 500;

  span {
    text-align: center;
  }
}

.m-check-table-menu,
.m-check-table-header {
  background-color: #f9f9f9;
}

.m-check-table-header,
.m-check-table-body {
  width: 100%;
  display: grid;
  grid-template-columns: var(--menu-width) minmax(0, 1fr);

  &.print { grid-template-columns: minmax(0, 1fr); }
}
</style>
